module.exports = __webpack_public_path__ + "assets/grinning_squinting_face.9e6784f50ff7da6beba268976e8195fe0431ba28d5d47444a4ee9ba3082cb3fd.png";